import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatNumberOrNa' })
export class FormatNumberOrNaPipe implements PipeTransform {
  static readonly DEFAULT_NULL_VALUE: string = 'N/A';

  static getFormattedNumber(src: any): string {
    let result: string = '';
    if (src === null || src === undefined) {
      result = FormatNumberOrNaPipe.DEFAULT_NULL_VALUE;
    } else {
      if (typeof src === 'number') {
        result = formatNumber(src, 'en-US');
      } else {
        result = this.getFormattedNumber(+src);
      }
    }

    // console.debug('getFormattedNumber src:' + src + ' result:' + result);

    return result;
  }

  static getFormattedNumberNaIfZero(aSrc: number | undefined): string {
    let result: string;
    if (!isNaN(aSrc) && aSrc === 0) {
      result = FormatNumberOrNaPipe.DEFAULT_NULL_VALUE;
    } else {
      result = this.getFormattedNumber(aSrc);
    }
    return result;
  }

  transform(src: any): string {
    return FormatNumberOrNaPipe.getFormattedNumber(src);
  }
}
